<template>
	<div class="chip" :style="chipStyle">
		<div v-if="icon" class="chip-icon" v-html="getIcon(icon)"></div>
		<p class="chip-text"><slot></slot></p>
	</div>
</template>

<script>
import {useSvgStore} from "@/shared/stores";

export default {
	name: "AppChip",
	setup() {
		const svgStore = useSvgStore();
		return {getIcon: svgStore.get};
	},
	props: {
		icon: {type: String, default: null},
		// Border + icon color
		color: {type: String, default: "var(--color-secondary)"},
		// Light fill behind the chip; defaults to a low-alpha tint of the secondary color
		bgColor: {type: String, default: "rgba(var(--rgb-secondary), .1)"},
	},
	computed: {
		chipStyle() {
			return {
				"--chip-color": this.color,
				"--chip-bg": this.bgColor,
			};
		},
	},
}
</script>

<style lang="scss" scoped>
.chip {
	@include noSelect;
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 5px 10px;
	border-radius: 15px;
	background-color: var(--chip-bg);
	//border: 1px solid var(--chip-color);

	.chip-icon {
		@include centered;
		width: 16px;
		height: 16px;
		flex-shrink: 0;

		:deep(svg) {
			width: 16px;
			height: 16px;

			.fill { fill: var(--chip-color); }
			.stroke { stroke: var(--chip-color); }
		}
	}

	.chip-text {
		font-size: 14px;
		line-height: 14px;
		color: var(--chip-color);
		white-space: nowrap;
	}

	@media (max-width: 520px) {
		padding: 5px;

		.chip-text {
			font-size: 12px;
		}
		.chip-icon {
			width: 12px;
			height: 12px;

			:deep(svg) {
				width: 12px;
				height: 12px;
			}
		}
	}
}
</style>
